module.exports = __webpack_public_path__ + "img/Progress-Report-Process-5.7a61b9c4.png";